import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import CrmCaseDo from "./CrmCaseDo";
import CrmCaseMove from "./CrmCaseMove";
import CrmForm from "./CrmForm";
import { Header } from '../Header';
import { Footer } from '../Footer';
import SendSms from "./SendSms";
import DatePicker from 'react-datepicker2';

export default class CrmCases extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            caller: props.Caller,
            controllerName: 'crm/case',
            IsV2: true,
            data: null,
            page: 1,
            per_page: 30000,
            phrase: '',
            loading: true,
            configName: 'crmcase_grid',
            moduleName: 'مدیریت ارتباط با مشتریان',
            systemModuleId: 25,
            moduleAccessStatus: 1,
            status: [],
            sorts: [],
            filterType: 1,
        };

        this.state.filters = {
            teamId: this.getCurrentFormId(),
            blacklist: false,
            archived: false,
            mobile: '',
            personCode: '',
            orderingDate: '',
            orderingDateConverted: ''
        };

        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        this.httpPost("api/v1/common/check/module/access", {
            systemModuleId: this.state.systemModuleId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.moduleAccessStatus = data.status;

                var p1 = this.httpPost("api/v1/crm/casestatus/list", {
                    filters: {
                        crmTeamId: this.state.filters.teamId,
                    }
                })
                    .then(data => {
                        if (data.status === -1) window.location.href = "/login";
                        if (data.status === 1) {
                            this.state.status = data.records;
                        }
                    });
                Promise.all([p1]).then(r => {
                    this.refreshData();
                });

            });
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <CrmForm TeamId={this.state.filters.teamId} Caller={this} Id={id} /> });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <CrmForm TeamId={this.state.filters.teamId} Caller={this} /> });
    }
    onDo(id) {
        this.removeKeyDown();
        this.showComponents({
            component: <CrmCaseDo Caller={this} Id={id} CrmCaseLogType={1} CrmTeamId={this.state.filters.teamId} />
        });
    }
    onView(id) {
        this.removeKeyDown();
        this.showComponents({
            component: <CrmCaseDo ViewMode={true} Caller={this} Id={id} CrmCaseLogType={1} CrmTeamId={this.state.filters.teamId} />
        });
    }
    onMove(id) {
        this.removeKeyDown();
        this.showComponents({
            component: <CrmCaseMove Caller={this} Id={id} />
        });
    }
    onContact(personId) {
        this.removeKeyDown();
        this.showComponents({
            component: <CrmCaseDo Caller={this} CrmCaseLogType={2} PersonId={personId} CrmTeamId={this.state.filters.teamId} />
        });
    }
    changeMode(mode) {
        this.state.filters.mode = mode;
        this.refreshData();
    }
    getRecordCount(statusId) {
        return this.getRecords(statusId).length;
    }
    getRecords(statusId) {
        var t = [];
        this.state.data.records.forEach(record => {
            if (record.crmCaseStatusId === statusId) {
                if (this.isBlank(this.state.phrase)) {
                    if (this.state.filterType === 1) t.push(record);
                    if (this.state.filterType === 2 && record.dueDateIsToday) t.push(record);
                    if (this.state.filterType === 3 && record.dueDateExpired) t.push(record);
                }
                else {
                    if (record.name.includes(this.state.phrase)) {
                        if (this.state.filterType === 1) t.push(record);
                        if (this.state.filterType === 2 && record.dueDateIsToday) t.push(record);
                        if (this.state.filterType === 3 && record.dueDateExpired) t.push(record);
                    }
                }
            }
        });
        if (this.getSort(statusId) === 1) return t.sort(function (a, b) {
            return ((b.editDateString < a.editDateString) ? -1 : ((b.editDateString == a.editDateString) ? 0 : 1));
        });
        if (this.getSort(statusId) === 2) return t.sort(function (a, b) {
            return ((a.editDateString < b.editDateString) ? -1 : ((a.editDateString == b.editDateString) ? 0 : 1));
        });
        return t;
    }
    getSort(stepId) {
        var v = 1;
        this.state.sorts.forEach(f => {
            if (f.stepId === stepId) v = f.value;
        });
        return v;
    }
    setSort(stepId, e) {
        var find = 0;
        this.state.sorts.forEach(f => {
            if (f.stepId === stepId) {
                find = 1;
                f.value = e;
            }
        });
        if (find === 0) this.state.sorts.push({ stepId: stepId, value: e });
        this.setState({ data: this.state.data });
    }
    sendSms(statusId) {
        var mobiles = [];
        this.getRecords(statusId).forEach(record => {
            if (!this.isEmpty(record.phone)) {
                mobiles.push(record.phone);
            }
        });
        this.showComponents({
            component: <SendSms Mobiles={mobiles} Caller={this} UseIn={'crm'} CrmTeams={this.state.filters.teamId} />
        });
    }
    renderRemainDueCount(stepId) {
        var c = 0;
        this.getRecords(stepId).forEach(f => {
            if (f.dueDateExpired) c++;
        });
        if (c <= 0) return null;
        return <p style={{ "background-color": "red", "text-align": "center", "color": "white", "border-radius": "4px" }}>تعداد {c} پیگیری در مهلت تعیین شده انجام نپذیرفته</p>
    }
    renderForm() {
        if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);

        return <div>
            <div className="nk-content-body">
                <div className="nk-block">
                    <div className="card card-bordered card-stretch mb-2">
                        <div className="card-inner position-relative card-tools-toggle">
                            <div className="card-tools">
                                <div className="form-inline flex-nowrap gx-3">
                                    <div className="form-wrap">
                                        <input style={{ "width": "130px" }} type="text" defaultValue={this.state.phrase} onChange={e => this.setState({ phrase: e.target.value })} placeholder="نام شخص" className="form-control" />
                                    </div>
                                    <div className="form-wrap">
                                        <input style={{ "width": "110px" }} defaultValue={this.state.filters.mobile} onChange={e => this.state.filters.mobile = e.target.value} type="text" className="form-control" placeholder="شماره موبایل" />
                                    </div>
                                    <div className="form-wrap">
                                        <input style={{"width": "90px"}} defaultValue={this.state.filters.personCode} onChange={e => this.state.filters.personCode = e.target.value} type="text" className="form-control" placeholder="کد شخص" />
                                    </div>
                                    <div className="form-group m-0 col">
                                        <DatePicker
                                            inputReadOnly={false}
                                            className="form-control persian-date ltr"
                                            placeholder={"تاریخ سفارش"}
                                            isGregorian={false}
                                            showTodayButton={true}
                                            timePicker={false}
                                            onChange={(e) => {
                                                this.state.filters.orderingDate = e;
                                                this.state.filters.orderingDateConverted = this.convertMomentToDb(e);
                                            }}
                                            value={this.getFormatedDateForDatePicker(this.state.filters.orderingDate)}
                                        />
                                    </div>
                                    <div className="form-wrap">
                                        <select defaultValue={this.state.filterType} onChange={e => this.setState({ filterType: parseInt(e.target.value) })} className="form-control">
                                            <option value="1">همه پیگیری ها</option>
                                            <option value="2">پیگیری های باز امروز</option>
                                            <option value="3">پیگیری های دارای تاخیر</option>
                                        </select>
                                    </div>
                                    <a onClick={e => this.refreshData(e)} className="hand btn btn-warning" style={{ "margin-right": "auto" }}><span>جستجو</span></a>
                                    <a onClick={e => this.onAdd()} className="hand btn btn-primary ms-2" style={{ "margin-right": "auto" }}><span className="shortcut">F2 - </span><span>افزودن پیگیری جدید</span></a>
                                    <a onClick={e => this.refreshData(e, "list", "excel")} className="hand btn btn-success ms-2"><span>دانلود اکسل</span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    {this.state.status.map(step =>
                        <div class="card text-white bg-white" style={{ "width": "30%", "float": "right", "margin-left": "3%", "margin-top": "0", "margin-bottom": "25px", "height": "400px" }}>
                            <div class="card-header" style={{ "background-color": (this.isBlank(step.color) ? "#f8a602" : step.color) }}>{step.title}</div>
                            <div class="card-inner" style={{ "overflow-y": "scroll" }}>
                                <div className="solution_cart_holder">
                                    <select defaultValue={this.getSort(step.id)} onChange={e => this.setSort(step.id, parseInt(e.target.value))} class="form-control text-center">
                                        <option value="1">جدیدترین</option>
                                        <option value="2">قدیمی ترین</option>
                                    </select>
                                    <li><a onClick={e => this.sendSms(step.id)} className="hand btn btn-warning" style={{"height": "25px"}}>ارسال پیامک</a></li>
                                    <span className="badg" style={{ "background-color": (this.isBlank(step.color) ? "#f8a602" : step.color) }}>{this.getRecordCount(step.id)}</span>
                                </div>
                                {this.renderRemainDueCount(step.id)}
                                {this.getRecords(step.id).map(record => <div className="project">
                                    <div className="project-head" style={{ "position": "relative" }}>
                                        {record.result === true && <em title="نتیجه حاصل شده است" class="icon ni ni-award text-warning" style={{ "position": "absolute", "left": "0", "font-size": "35px", "top": "0" }}></em>}
                                        {record.result === false && <em title="به نتیجه نرسیده است" class="icon ni ni-spark-off text-danger" style={{ "position": "absolute", "left": "0", "font-size": "35px", "top": "0" }}></em>}
                                        
                                        <a onClick={e => ((record.kartablUserId === null || record.kartablUserId === this.state.data.global.user.id)) ? this.onDo(record.id) : this.onView(record.id)} className="hand project-title">
                                            <div className="project-info">
                                                <span className="text-black">{record.dueDateExpired && <span title="مهلت پیگیری تمام شده" style={{"width": "10px","height": "10px","display": "inline-block","background-color": "red","border-radius": "100%"}}></span>} {record.name}</span>
                                                {!this.isBlank(record.kartablUserName) && <span className="text-gray block" style={{ "display": "block" }} >مسئول: {record.kartablUserName}</span>}
                                                <span className="text-gray block" style={{ "display": "block" }} >{record.sourceName} - {record.createDateString}</span>
                                                {!this.isBlank(record.dueDateString) && <span className="text-danger">مهلت پیگیری: {record.dueDateString}</span>}
                                                {this.state.data.global.company.mainBussinessType !== 3 && <span className="sub-text">بروزرسانی: {record.editDateString}</span>}

                                                {!this.isBlank(record.orderingParentId) && <span className="sub-text">تاریخ کشت: {record.orderingParentDateString}</span>}
                                                {!this.isBlank(record.orderingParentId) && <span className="sub-text">شماره کشت: {record.orderingParentFullNumber}</span>}
                                                {!this.isBlank(record.orderingParentId) && <span className="sub-text">شماره تونل: {record.orderingParentProductionLines.join(' و ')}</span>}
                                                {this.state.data.global.company.mainBussinessType !== 3 && !this.isBlank(record.orderingId) && <span className="sub-text">شماره سفارش: {record.orderingFullNumber}</span>}
                                                {!this.isBlank(record.orderingId) && <span className="sub-text">تاریخ سفارش: {record.orderingDateString}</span>}

                                                {!this.isBlank(record.factorId) && <span className="sub-text">شماره فاکتور: {record.factorNumber}</span>}
                                                {!this.isBlank(record.factorId) && <span className="sub-text">تاریخ فاکتور: {record.factorDateString}</span>}
                                            </div>
                                        </a>
                                    </div>
                                    <div className="project-meta" style={{ "border-bottom": "solid 1px #e8e8e8", "padding-bottom": "10px", "margin-bottom": "10px" }}>
                                        {(record.kartablUserId === null || record.kartablUserId === this.state.data.global.user.id) ? <a onClick={e => this.onDo(record.id)} className="hand">
                                            <span className="nk-menu-text text-warning"><em className="icon ni ni-eye"></em> پیگیری</span>
                                        </a> :
                                            <a onClick={e => this.onView(record.id)} className="hand">
                                                <span className="nk-menu-text text-warning"><em className="icon ni ni-eye"></em> سوابق</span>
                                            </a>
                                        }
                                        <a onClick={e => this.onMove(record.id)} className="hand">
                                            <span className="nk-menu-text text-danger"><em className="icon ni ni-move"></em> تغییر تیم</span>
                                        </a>
                                        <a onClick={e => this.onContact(record.personId)} className="hand">
                                            <span className="nk-menu-text text-success"><em className="icon ni ni-chat-circle"></em> تماس/مکاتبه</span>
                                        </a>
                                    </div>
                                </div>
                                )}
                            </div>
                        </div>)}
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.isEmpty(this.state.data.global.companies) ? this.renderNoCompanyRegister() : this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />,
                this.renderPopupComponent(),
            ];

        return contents;
    }
}